<template>
    <div>
        <CabecalhoCadastro
            descricao="Lançamento Respostas"
            :pesquisar="pesquisar"
            :botoes="botoesCabecalho"

        />
    </div>
</template>

<script>

export default {

    data() {
        return {
            botoesCabecalho:[
                {funcao: this.cadastrar, icone: 'add', tooltip: 'Cadastro', cor: 'blue'}
            ]
        }
    },

    methods: {

        pesquisar(valor) {
            console.log('Pesquisar: ' + valor)
        },

        cadastrar() {
            console.log('Cadastrar')
        }

    }
}

</script>